import React from "react";
import Feed from "./personalized-feed/Feed.js";
import NoPageFound from './errors/NoPageFound';

const routes = [

  {
    path: "/",
    element: <Feed/>,
    initialAction: Feed.initialAction,
  },
  {
    path: "/baby-0-2-years",
    element: <Feed />,
    initialAction: Feed.initialAction,
  },
  {
    path: "/toddler-2-4-years",
    element: <Feed />,
    initialAction: Feed.initialAction,
  },
  {
    path: "/kid-4-plus-years",
    element: <Feed />,
    initialAction: Feed.initialAction,
  },
  {
    path: "/expecting",
    element: <Feed/>,
    initialAction: Feed.initialAction,
  },
  {
    path: "/trying-to-conceive",
    element: <Feed />,
    initialAction: Feed.initialAction,
  },
  {
    path: "/infant-0-6-months",
    element: <Feed />,
    initialAction: Feed.initialAction,
  },
  {
    path: "/big-kid-6-plus-years",
    element: <Feed />,
    initialAction: Feed.initialAction,
  },
  {
    element: NoPageFound,
    status: 404
  }
];

export default routes;
